<template>
  <div class="">
    <discount-rate-card-top :logo="logo"></discount-rate-card-top>
    <div class="tc c999" v-if="cuDiscountRate.length==0">该银行今天尚未发布报价</div>
    <div v-else>
      <!-- <div class="tl mb10"><span class="f14 c999">更新时间：{{new Date().pattern('yyyy-MM-dd')}}</span></div> -->
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr class="c666 hl30" style="background: #FFF5F5">
          <!-- <td class="bre3e8ee" :rowspan="2">票据类型</td> -->
          <td class="bFFD4D4 pr" :rowspan="2">
            <div class="rowspan_style">
              银行类型
            </div>
          </td>
          <td class="brFFD4D4 btFFD4D4 bbFFD4D4 pr" :rowspan="2">
            <div class="rowspan_style">
              到期日
            </div>
          </td>
          <td class="brFFD4D4 bbFFD4D4 btFFD4D4" :colspan="cuDiscountRate[0].arrayList ? cuDiscountRate[0].arrayList.length : 1">票面金额（万元）</td>
          <td class="btFFD4D4 bbFFD4D4 brFFD4D4 bbccc brccc plr10 ptb20 l18 c666 tl pr" :rowspan="2" style="width: 200px;">
            <div class="rowspan_style">
              承兑行
            </div>
          </td>
        </tr>

        <tr class="c666 hl30" style="background: #FFF5F5">
          <td class="brFFD4D4 bbFFD4D4" v-for="(item3, index3) in cuDiscountRate[0].arrayList">{{item3.ebillAmt}}</td>
        </tr>

        <tr class="hl40" v-for="(body, index3) in dataList" :key="index3">
          <!-- <td class="bbe3e8ee bre3e8ee" :rowspan="body.draftTypeTotal" v-if="body.draftTypeTotal">{{formatDict(body.draftType, 'draftType')}}</td> -->
          <td class="bbccc brccc blccc c333 fb" :rowspan="body.acceptBankLevelTypeTotal" v-if="body.acceptBankLevelTypeTotal">{{getBankLevel(body.bankLevel)}}</td>
          <td class="bbccc brccc c666">{{formatDate(body)}}</td>
          <!-- <td class="bbccc brccc c666" v-else v-html="body.dueDateShow"></td> -->
          <td class="bbccc brccc c000 fb" v-for="(item3, index3) in body.arrayList">{{changeRate(item3.billRate)}}</td>
          <td class="bbccc brccc plr10 ptb20 l18 c666 tl" :rowspan="body.acceptBankLevelTypeTotal" v-if="body.acceptBankLevelTypeTotal">
            <div :class="body.extend?'':'extend-text'">{{acceptingBank(body.bankLevel)}} </div><span v-if="levelBankList[body.bankLevel]&& levelBankList[body.bankLevel][0].split('、').length >= 10" class="extend" @click="extendChange(body)">{{body.extend?'收起': '展开'}}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import DiscountRateCardTop from './DiscountRateCardTop.vue';
export default {
  components: { DiscountRateCardTop },
  name: 'discountRateCard',
  props: ['cuDiscountRate', 'levelBankList', 'logo', 'bankName', 'type'],
  data () {
    return {
      dataList: []
    }
  },
  watch: {
    cuDiscountRate: {
      handler (new_) {
        const list = Object.assign([], this.cuDiscountRate)
        list.map(item => {
          if (this.levelBankList[item.bankLevel] && this.levelBankList[item.bankLevel].length === 1 && this.levelBankList[item.bankLevel][0].split('、').length >= 10) {
            Object.assign(item, { extend: false })
          }
        })
        this.dataList = list
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    console.log('=============logo', this.logo, this.cuDiscountRate)
  },
  methods: {
    // 利率
    changeRate (rate) {
      if (String(rate).indexOf('%') > -1) {
        return rate;
      } else if (rate) {
        let decimal = String(rate)
        // 最少保留两位小数，超出的不做四舍五入
        if (decimal.split('.')[1].length >= 4) {
          console.log(rate)
          return Number(rate).mul(100) + '%';
        } else {
          console.log(rate, Number(rate).mul(100));
          return Number(rate).mul(100).toFixed('2') + '%';
        }
      } else {
        return '0.00%';
      }
    },
    // 承兑行
    acceptingBank (bankLevel) {
      if (this.type === 'fm') {
        // 富民自渠道
        if (this.levelBankList[bankLevel].length > 0) {
          return `${this.getBankLevel(bankLevel)}${this.levelBankList[bankLevel].length}个：${this.levelBankList[bankLevel] && this.levelBankList[bankLevel].join('、')}`
        }
      }
      // rzline配置
      if (this.levelBankList[bankLevel] && this.levelBankList[bankLevel].length === 1) {
        let length = this.levelBankList[bankLevel][0] ? this.levelBankList[bankLevel][0].split('、').length : 0
        if (length > 0) {
          return `${this.getBankLevel(bankLevel)}${length}个：${this.levelBankList[bankLevel] && this.levelBankList[bankLevel]}`
        }
      }

      return '';
    },
    // 几类行
    getBankLevel (bankLevel) {
      // 富民自渠道
      if (this.type === 'fm') {
        return this.formatDict(bankLevel, 'acceptorLevel')
      }
      // rzline配置
      return this.formatDict(bankLevel, 'acceptorLevel')
    },
    // optimizeBank (bank) {
    //   // 优化 平安、微众、红塔、华润、 三湘银行 将天数转化为日期显示,格式“截至2022/05/31含”
    //   if (bank === 'PINGAN' || bank === 'HUARUN' || bank === 'WZ' || bank === 'YNHT' || bank === 'SANXIANG') return true
    // },
    formatDate (body) {
      // 格式化日期
      let str = ''
      if (body.dueType === 'DUE_DAY') {
        // 三湘银行到期日 包含第零天 因此减1天
        str = '截至' + this.DateAdd('d', body.bankCode !== 'SANXIANG' ? body.dueDayMax : body.dueDayMax - 1) + '含'
      } else {
        if (body.dueDate.length <= 10) {
          str = '截至' + body.dueDate.split('-').join('/') + '含'
        } else {
          str = body.dueDate
        }
      }
      return str

    },
    extendChange (e) {
      this.dataList.map(item => {
        if (item.bankLevel === e.bankLevel) {
          item.extend = !item.extend
        }
      })
      this.dataList = Object.assign([], this.dataList,)
    }
  },

}
</script>

<style lang="scss" scoped>
.fw500 {
  font-weight: 500;
}
.rowspan_style {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.extend {
  color: #3193d9;
  cursor: pointer;
}
.extend-text {
  height: 160px;
  overflow: hidden;
  -webkit-line-clamp: 9;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
table {
  background: url(~@/assets/img/discountTrends/LOGO.png) repeat center center;
  // background-size: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/common/DiscountRateCard.vue